import React from 'react';
import ReactDOM from 'react-dom';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

function SessionExpired(props) {

    const logout = (() => {
        ReactDOM.render(null, document.getElementById("app-alerts"))
        localStorage.clear()
        window.location.pathname = '/signin'
    })

    return <Dialog
        open={props?.status}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            {"Session has timed out"}
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                {props?.description}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button autoFocus style={{ color: "#029E4A" }} onClick={() => logout()}>
                Okay
            </Button>
        </DialogActions>
    </Dialog>

}

export default SessionExpired;